<div #divcontainer>
  <h2 [translate]="'widgets.teamMood.dailyOverview'">Daily overview</h2>

  <table class="contentTable">
    <tr>
      <td class="navigationColumn">
        <svg id="navigationTimeRangeLeft" class="nav-arrow">
          <path d="M31.122 2.828L29.708 0L0 59.414L29.708 118.828L31.122 116L2.829 59.414L31.122 2.828Z"/>
        </svg>
      </td>
      <td class="contentColumn">
        <div>
          <label>Start: </label>
          <mat-form-field class="datepicker">
            <input matInput [matDatepicker]="startDatePicker" [formControl]="startSerializedDate" readonly="true" [value]="startDate" (dateChange)="startDateChange($event)">
            <mat-datepicker-toggle matSuffix [for]="startDatePicker"></mat-datepicker-toggle>
            <mat-datepicker #startDatePicker></mat-datepicker>
          </mat-form-field>

          <label>Ende: </label>
          <mat-form-field  class="datepicker">
            <input matInput [matDatepicker]="endDatePicker" [formControl]="endSerializedDate" readonly="true" [value]="endDate" (dateChange)="endDateChange($event)">
            <mat-datepicker-toggle matSuffix [for]="endDatePicker"></mat-datepicker-toggle>
            <mat-datepicker #endDatePicker></mat-datepicker>
          </mat-form-field>
        </div>
        <div class="canvasContainer">
          <canvas id="{{chartId}}"></canvas>
        </div>

        <div class="line-hr">
          <mat-divider></mat-divider>
        </div>

        <h2 [translate]="'widgets.teamMood.numberOfVote'">Number of votes per day</h2>
        <div class="canvasContainer">
          <canvas id="{{barChartId}}"></canvas>
        </div>
      </td>
      <td class="navigationColumn">
        <svg id="navigationTimeRangeRight" class="nav-arrow">
          <path d="M-0.000175476 116L1.41383 118.828L31.1218 59.4141L1.41383 0.00012207L-0.000175476 2.82813L28.2928 59.4141L-0.000175476 116Z"/>
        </svg>
      </td>
    </tr>
  </table>
</div>
